import { createStandardAction } from 'typesafe-actions';

export const updateChaptersVisibility = createStandardAction(
  'chapters/TOGGLE_VISIBILITY'
)<{
  isVisible: boolean;
  initiatedBy?: 'click';
}>();
